import ProductCounter from "@/components/inputs/ProductCounter/ProductCounter";

import styles from "./OptionsSection.module.scss";

const OptionsSection = ({ experience, currency }) => {
  const { options } = experience;
  const currencyCode = currency.code.toLowerCase();

  // const optionCounters = options.map((optionObject, index) => {
  //   const { option, currencies } = optionObject;
  //   const currencyPrice =
  //     currencies !== null &&
  //     currencies !== "null" &&
  //     currencies.hasOwnProperty(currencyCode)
  //       ? currencies[currencyCode]
  //       : "N/A";
  //   return (
  //     <ProductCounter title={option.name} price={currencyPrice} key={index} />
  //   );
  // });

  const staticOptions = options.map((option, index) => {
    // const { option } = optionObject;
    const currencies = option?.currencies ?? null;

    const currencyPrice =
      currencies &&
      currencies !== null &&
      currencies.hasOwnProperty(currencyCode)
        ? currencies[currencyCode]
        : false;

    return (
      <li key={index} className={`${styles.optionItem}`}>
        <span className={`${styles.name}`}>{option.name}</span>
        <span className={`${styles.price}`}>
          {currencyPrice && (
            <>
              <span>{currency.symbol}</span>
              {currencyPrice}
            </>
          )}
        </span>
      </li>
    );
  });
  return (
    <div className={`${styles.optionsContainer}`}>
      <ul className={`${styles.optionsList}`}>{staticOptions}</ul>
    </div>
  );
};

export default OptionsSection;
